import { ReactComponent } from "./close-line.svg";

interface Props {
  fill?: string;
  style?: React.CSSProperties;
}

const CloseLineIcon: React.FC<Props> = (props) => <ReactComponent {...props} />;

export default CloseLineIcon;
